// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__38u9j","selects":"Documents_selects__2DzdC"};